<template>
  <div class="row">
    <div class="col-12">
      <h4 class="text-center mb-3">Usuários</h4>

      <DataTable
        :value="users"
        :lazy="true"
        :paginator="true"
        :rows="10"
        :rows-per-page-options="[10, 25, 50]"
        :total-records="total_users"
        :loading="loading"
        :row-hover="true"
        @page="onPage($event)"
        @sort="onSort($event)"
        ref="datatable"
        data-key="id"
        class="p-datatable-gridlines p-datatable-sm"
      >
        <template #empty> Nenhum resultado </template>
        <template #loading> Carregando </template>
        <Column field="name" header="Nome"></Column>
        <Column field="email" header="Email"></Column>
        <Column field="user_profile.name" header="Perfil"></Column>
        <Column>
          <template #body="slotProps">
            <div class="d-flex flex-nowrap justify-content-end">
              <router-link :to="'/users/edit/' + slotProps.data.id">
                <button class="btn btn-warning ml-3">
                  <font-awesome-icon
                    :icon="['fas', 'wrench']"
                  ></font-awesome-icon>
                </button>
              </router-link>

              <button
                class="btn btn-danger ml-3"
                @click="onDelete(slotProps.data.id, slotProps.index)"
              >
                <font-awesome-icon :icon="['fas', 'trash']"></font-awesome-icon>
              </button>
            </div>
          </template>
        </Column>
      </DataTable>

      <router-link to="/users/create" class="btn btn-dark mt-3">
        <font-awesome-icon :icon="['fas', 'save']"></font-awesome-icon>
        Novo usuário
      </router-link>
    </div>
  </div>
</template>

<script>
  import { ref, onMounted } from 'vue'

  import Column from 'primevue/column'
  import DataTable from 'primevue/datatable'

  import useSwal from '@/modules/Swal.js'
  import useUser from '@/modules/User.js'

  export default {
    components: {
      Column,
      DataTable,
    },
    setup() {
      const page = ref(1)
      const per_page = ref(10)
      const datatable = ref(null)

      const { users, total_users, loading, listUsers, destroyUser } = useUser()

      const onPage = (event) => {
        page.value = event.page + 1

        listUsers(page.value, per_page.value)
      }

      const { showConfirmDeletionSwal } = useSwal()

      onMounted(async () => {
        await listUsers(page.value, per_page.value)
      })

      return {
        loading,
        datatable,
        total_users,
        users,
        showConfirmDeletionSwal,
        onPage,
        destroyUser,
      }
    },
    methods: {
      onDelete(user_id, index) {
        this.showConfirmDeletionSwal()
          .then((response) => {
            if (response.isConfirmed) {
              this.destroyUser(user_id, index)
            }
          })
          .catch((error) => {
            console.log(error)
          })
      },
    },
  }
</script>
